export enum ErrorRoutes {
  Generic = '/error',
  Sorry = '/sorry',
}
